import { Component } from '@angular/core';

@Component({
  selector: 'app-video-production',
  imports: [],
  templateUrl: './video-production.component.html',
  styleUrl: './video-production.component.scss',
})
export class VideoProductionComponent {}
